<script lang="ts">
  import CharityDetail from '../../components/employee/charities/CharityDetail.svelte';
  import { params } from 'svelte-spa-router';
  import { onMount } from 'svelte';
  
  // Get id from route params store - handle both store and direct access
  let charityId = '';
  
  // Update charityId reactively when params change
  $: {
    if ($params && typeof $params === 'object' && 'id' in $params) {
      const newId = ($params.id as string) || '';
      if (newId !== charityId) {
        charityId = newId;
      }
    }
  }
  
  // Also check params on mount in case reactive statement doesn't fire immediately
  onMount(() => {
    if ($params && typeof $params === 'object' && 'id' in $params) {
      charityId = ($params.id as string) || '';
    }
  });
</script>

<CharityDetail {charityId} />

